import { Link, useSearchParams } from 'react-router-dom';
import PageShell, { PageTitle } from '../components/PageShell';
import ArticleList from '../components/ArticleList';
import CallButton from '../components/CallButton';
import HelpBox from '../components/HelpBox';
import { ARTICLE_CATEGORIES, ARTICLES } from '../constants/articles';

function matches(article, query) {
  const haystack = [
    article.title,
    article.excerpt,
    ...article.intro,
    ...article.sections.map((s) => s.heading),
  ]
    .join(' ')
    .toLowerCase();
  return query
    .toLowerCase()
    .split(/\s+/)
    .every((word) => haystack.includes(word));
}

export default function BlogsPage() {
  const [params, setParams] = useSearchParams();
  const query = (params.get('q') || '').trim();
  const results = query ? ARTICLES.filter((a) => matches(a, query)) : null;

  const handleSubmit = (event) => {
    event.preventDefault();
    const q = String(new FormData(event.currentTarget).get('q') || '').trim();
    setParams(q ? { q } : {});
  };

  return (
    <PageShell>
      <PageTitle
        title="Family Tree Maker How-To Library"
        lead="Free, jargon-free walkthroughs written by the technicians who answer these questions every day."
        crumbs={[{ label: 'Blogs' }]}
      />

      <form className="search-form" role="search" onSubmit={handleSubmit}>
        <label htmlFor="blog-search" className="sr-only">
          Search guides
        </label>
        <input
          id="blog-search"
          name="q"
          type="search"
          defaultValue={query}
          key={query}
          placeholder="What do you need help with? e.g. missing photos"
        />
        <button type="submit">Find a guide</button>
      </form>

      <CallButton />

      {results ? (
        <section className="entry-section">
          <h2>
            We found {results.length} guide{results.length === 1 ? '' : 's'} matching “{query}”
          </h2>
          {results.length ? (
            <ArticleList articles={results} />
          ) : (
            <p className="text-center">
              Nothing matched that search. Try a different word, or call us and we will answer it
              personally.
            </p>
          )}
          <p className="text-center">
            <Link to="/blogs">Back to the full library</Link>
          </p>
        </section>
      ) : (
        ARTICLE_CATEGORIES.map((cat) => (
          <section key={cat.key} className="entry-section">
            <h2>
              <Link to={cat.hub} className="heading-link">
                {cat.label}
              </Link>
            </h2>
            <ArticleList articles={ARTICLES.filter((a) => a.category === cat.key)} />
            <CallButton />
          </section>
        ))
      )}

      <HelpBox
        title="Didn’t See Your Problem Listed?"
        text="Every tree is different. Describe what is happening and a technician will give you an answer tailored to your setup."
      />
    </PageShell>
  );
}
